module.exports = __webpack_public_path__ + "static/media/main.69da8e16.jpg";